import { render } from "./PeopleEmpty.vue?vue&type=template&id=07ba6aeb&scoped=true"
import script from "./PeopleEmpty.vue?vue&type=script&lang=js"
export * from "./PeopleEmpty.vue?vue&type=script&lang=js"

import "./PeopleEmpty.vue?vue&type=style&index=0&id=07ba6aeb&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ba6aeb"]])

export default __exports__